<!-- 孩子装备信息  被动技能  图腾技能 -->
<template>
  <div class="TableContent TableContents_1">
    <p class="setctionTitle">装备信息</p>
    <div class="equip_pics">
      <mCommonItem
        :content="one['content']"
        v-for="(one, o_index) in one_child.new_equs"
        :key="o_index"
        :src="item_img(one['id'])"
        :class="`equip_pic equip_pic${o_index}`"
      >
        <template v-slot:title>
          <span
            class="tooltip_title tooltip_title_color"
            :style="{ color: `#${one['name_color']}` }"
          >
            {{ one['name'] }}
          </span>
        </template>
      </mCommonItem>

      <mCommonItem
        :content="`${child.wing_eff}${child.wing_tips}`"
        :title="child.wing_name"
        :src="child_wing_img(child.wing_name)"
        :class="`equip_pic equip_pic_chibang`"
        v-if="one_child?.child?.wing_tips"
      >
      </mCommonItem>
      
      <mCommonItem
        :content="one['content']"
        v-for="(one, o_index) in one_child.fashions"
        :key="o_index"
        :src="item_img(one['id'])"
        :class="`equip_pic equip_pic${o_index}`"
      >
        <template v-slot:title>
          <span
            class="tooltip_title tooltip_title_color"
            :style="{ color: `#${one['name_color']}` }"
          >
            {{ one['name'] }}
          </span>
        </template>
      </mCommonItem>

      <img :src="child_sex_img(child.sex)" />
    </div>

    <div class="passive_skill skill-com" v-if="new_skills.length > 0">
      <p>被动技能</p>
      <div class="grid-3">
        <mCommonItem
          :name="one.name || ''"
          :content="one.intro || ''"
          :score="one.level || 0"
          v-for="(one, i) in new_skills"
          :key="i"
          :src="child_pskill_img(one.new_img_id)"
        >
          <template v-slot:title>
            <span class="tooltip_title tooltip_title_color">
              {{ one.name }}
            </span>
          </template>
        </mCommonItem>
      </div>
    </div>

    <div class="totem_skill skill-com" v-if="new_tskills.length > 0">
      <p>图腾技能</p>
      <div class="grid-3">
        <mCommonItem
          :name="one.name || ''"
          :content="one.desc || ''"
          :score="one.level || 0"
          v-for="(one, i) in new_tskills"
          :key="i"
          :src="child_tskill_img(one.new_img_id)"
        >
          <template v-slot:title>
            <span class="tooltip_title tooltip_title_color">
              {{ one.name }}
            </span>
          </template>
        </mCommonItem>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue';

const { child_tskill_img, child_pskill_img, child_sex_img, item_img,child_wing_img } = inject('filters');

const props = defineProps({
  one_child: {
    type: Object,
    default: () => ({}),
  },
});

const child = computed(() => {
  return props.one_child?.child || {};
})

const new_skills = computed(() => {
  return props.one_child?.new_skills || [];
})

const new_tskills = computed(() => {
  return props.one_child?.new_tskills || [];
})
</script>

<style lang="scss" scoped>
.skill-com{
  width: 100%
}
</style>